/**
 * @desc 删除
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(id: number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/centerCountyMapping/${id}`, {
      method: "DELETE",

      ...options,
    }),
  );
}
